import { File } from '@web-std/file';

export const filePdf: File = new File(
    ['test', ' ', 'invalid pdf content'],
    'pv.pdf',
    { type: 'application/pdf' },
);

export const filePng: File = new File(
    ['test', ' ', 'invalid image content'],
    'foo.png',
    { type: 'image/png' },
);

export const file: File = filePdf;
